let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cCK4e")).then(() => parcelRequire('5R9cq'));